<template>
  <div class="yhgl-wrap">
    <div class="yhgl-top">
      <div class="yhgl-top-right">
        <div v-if="doadd" :class="[{ yhglchecked2: clickIndex2 == 0 }]" @click="operation(0)">创建</div>
        <!-- <div
          v-if="doupdate"
          :class="[{ yhglchecked2: clickIndex2 == 1 }]"
          @click="operation(1)"
        >
          修改
        </div>-->
        <div v-if="dodelete" :class="[{ yhglchecked2: clickIndex2 == 2 }]" @click="operation(2)">删除</div>
      </div>
    </div>
    <div class="yhgl-container">
      <img src="../assets/image/lq-bg.png" alt />
      <div>
        <div class="yhgl-con-wrap">
          <div class="yhgl-con-title">
            <div>序号</div>
            <div>会员卡类型</div>
            <div>房价码</div>
          </div>
          <div class="yhgl-con-contaniner">
            <transition-group name="list">
              <div
                :class="['yhgl-con-item', { rychecked: fangjiamaIndex2 == index }]"
                v-for="(item, index) in list"
                :key="index"
                @click="chooseRy(index)"
                @dblclick="dblItem(index)"
              >
                <div>{{ index + 1 }}</div>

                <div>{{ item.membertypename }}</div>
                <div>{{ item.ratetypename }}</div>
              </div>
            </transition-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

 

<script>
import { getRequest } from "@/api/api1.js";
export default {
  data() {
    return {
      dosee: false,
      doadd: false,
      doupdate: false,
      dodelete: false
    };
  },
  computed: {
    fangjiamaIndex2() {
      return this.$store.state.fangjiamaIndex2;
    },
    clickIndex2() {
      return this.$store.state.operationIndex2;
    },
    list() {
      return this.$store.state.tRoomRate2;
    }
  },
  created() {
    let that = this;
    this.dosee = this.power.checkedpower("1003000");
    this.doadd = this.power.checkedpower("1003001");
    this.doupdate = this.power.checkedpower("1003002");
    this.dodelete = this.power.checkedpower("1003003");

    if (this.dosee == false) {
      this.$router.push("/power");
    }
    if (this.list.length < 1) {
      let loadingInstance = this.$loading({
        text: "加载中"
      });
      getRequest("tGroupMemberRate/selectAll").then(res => {
        
        this.$nextTick(() => {
          loadingInstance.close();
        });
        if (res.status == 200) {
          let list = JSON.parse(JSON.stringify(res.data));
          that.$store.state.tRoomRate2 = list;
        } else {
          this.$mymessage({
            content: res.message,
            type: "error",
            time: 3000,
            hasClose: true
          });
        }
      });
    }
  },

  methods: {
    operation(index) {
      
      if (index == 0) {
        this.$store.state.operationIndex2 = index;
        let obj = {
          operation: "创建"
        };
        this.$hyfjm({ obj });
      } else if (index == 2) {
        if (this.$store.state.fangjiamaIndex2 != null) {
          this.$store.state.operationIndex2 = index;

          let obj = JSON.parse(
            JSON.stringify(
              this.$store.state.tRoomRate2[this.$store.state.fangjiamaIndex2]
            )
          );

          obj.title = "删除";
          obj.message = "您确定要删除吗";
          obj.fangjiamaIndex2 = this.$store.state.fangjiamaIndex2;

          this.$confirm({ obj });
        } else {
          this.$mymessage({
            content: "请选择删除内容",
            type: "error",
            time: 3000,
            hasClose: true
          });
        }
      }
    },
    chooseRy(index) {
      this.$store.state.fangjiamaIndex2 = index;
    },
    dblItem(index) {
      this.$store.state.fangjiamaIndex2 = index;
    }
  }
};
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.yhgl-wrap {
  width: 102%;
  margin-left: -1%;
  height: 100%;
  z-index: 999;
  position: relative;
  overflow: hidden;
}
.yhgl-top {
  width: 100%;
  height: 7%;
  padding: 0 3%;
  /* background: red; */
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 2%;
}

.yhgl-top-right div {
  width: 30%;
  height: 60%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
}
.yhglchecked,
.yhglchecked2 {
  background: url(../assets/image/lq-bg2.png);
  color: #fb7a01;
  background-size: 100% 100%;
  font-weight: bolder;
}
.yhgl-top-right {
  width: 20%;
  height: 90%;
  box-shadow: 8px 8px 20px #b9ccec, -8px -8px 15px #ffffff;
  border-radius: 7px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 0.8em;
  color: #575f6b;
  padding: 0 1%;
}
.yhgl-container {
  width: 100%;
  height: 93%;
  margin: 0 0 0;
  position: absolute;
  top: 8.5%;
}
.yhgl-container img {
  width: 100%;
  height: 100%;
  position: absolute;
}
.yhgl-container > div {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  padding: 2% 3%;
  overflow: hidden;
}
.yhgl-con-wrap {
  width: 100%;
  height: 100%;
  padding: 1%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.yhgl-con-title {
  width: 100%;
  display: flex;
  flex-shrink: 0;
}
.yhgl-con-title div {
  text-align: center;
  color: #2c3036;
  font-size: 0.8em;
  line-height: 3.2em;
  width: 10.5%;
}
.yhgl-con-title div:nth-child(9) {
  width: 35%;
}
.yhgl-con-contaniner {
  color: #6d798e;
  font-size: 14px;
  flex: 1;
  overflow: auto;
}
.yhgl-con-item {
  display: flex;
  width: 100%;
  border: 1px solid transparent;
  cursor: pointer;
}
.yhgl-con-item div {
  text-align: center;
  line-height: 3em;
  width: 10.5%;
  overflow: hidden;
}
.yhgl-con-item div:nth-child(9) {
  width: 35%;
}
.yhgl-con-contaniner .rychecked {
  box-shadow: 3px 3px 4px #a0bdee inset, -3px -3px 4px white inset;
  border: 1px solid #1471fe;
  border-radius: 10px;
}
.list-enter-active,
.list-leave-active {
  transition: all 1s;
}
.list-enter
/* .list-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(100%);
}
.list-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}
</style>